import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17.25V6.75C9.99741 6.55189 9.91756 6.36263 9.77747 6.22253C9.63737 6.08244 9.44811 6.00259 9.25 6H7.75C7.55189 6.00259 7.36263 6.08244 7.22253 6.22253C7.08244 6.36263 7.00259 6.55189 7 6.75V17.25C7.00259 17.4481 7.08244 17.6374 7.22253 17.7775C7.36263 17.9176 7.55189 17.9974 7.75 18H9.25C9.44811 17.9974 9.63737 17.9176 9.77747 17.7775C9.91756 17.6374 9.99741 17.4481 10 17.25ZM14.75 6H16.25C16.4481 6.00259 16.6374 6.08244 16.7775 6.22253C16.9176 6.36263 16.9974 6.55189 17 6.75V17.25C16.9974 17.4481 16.9176 17.6374 16.7775 17.7775C16.6374 17.9176 16.4481 17.9974 16.25 18H14.75C14.5519 17.9974 14.3626 17.9176 14.2225 17.7775C14.0824 17.6374 14.0026 17.4481 14 17.25V6.75C14.0026 6.55189 14.0824 6.36263 14.2225 6.22253C14.3626 6.08244 14.5519 6.00259 14.75 6Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgPauseOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPauseOutline;
